import React, { useState, useEffect } from "react";

export const svg = `<svg width="48" height="48" viewbox="0 0 48 48" viewBox="0 0 48 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M26 5V4C27.3364 4.44305 30.1418 5.79146 32.0806 6.94724C34.504 8.39196 36 9.98116 36 14.3153C36 16.4057 35.7748 19.3352 35.5381 22.415C35.4969 22.9502 35.4555 23.4899 35.4147 24.0305L23.9999 19.3303V7.00012L26 5Z"></path><path d="M21.9999 6.99989L20 5V4C17.0978 4.54899 14.0564 5.87814 12.9793 6.42714C11.9022 6.97613 9.91025 8.13945 10 11C10.0441 12.4057 10.2864 15.0863 10.5214 17.6866C10.7541 20.2621 10.9798 22.7588 10.9987 23.8602L21.9999 19.3303V6.99989Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.7621 26.1206C10.7473 26.2309 10.732 26.3442 10.7165 26.46C10.4208 28.6588 10 31.7883 10 34C10 37.4095 12.7526 46 22.2371 46C31.7215 46 34.9574 39.2274 35 32C35.0104 30.2411 35.1198 28.2144 35.2627 26.1308L22.9999 21.0815L10.7621 26.1206Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
